import { MESSAGE_ASSIST_SCHEMA } from '../constants';
import { isValidUrl } from '../helpers';
import { postScheduledRedirectMessage } from '../messageassist';
import { locationAssign } from './windowUtils';

// a wrapper around window redirect logic
// that interprets message assist redirect schema.
export default async function executeRedirect(target: string): Promise<void> {
    if (!isValidUrl(target)) {
        throw new Error(`Invalid redirect target: ${target}`);
    }

    if (target.startsWith(MESSAGE_ASSIST_SCHEMA)) {
        await postScheduledRedirectMessage(target);
        return;
    }

    locationAssign(target);
}
